module.exports = __WEBPACK_EXTERNAL_MODULE_43__;


/*****************
 ** WEBPACK FOOTER
 ** external {"amd":"exports","commonjs":"dom-storage","commonjs2":"dom-storage","root":"localStorage"}
 ** module id = 43
 ** module chunks = 0
 **/